import { Axios } from "index";
export const fleeceItemSrnoDropdownApi = "/fleece-inventory/item-srno-dropdown";
export const fleeceInwardSrnoDropdownApi =
  "/fleece-inventory/inward-srno-dropdown";
export const fleeceAddInventoryApi = "/fleece-inventory/add-inventory";
export const fleeceListingApi = "/fleece-inventory/list-inventory";
export const fleeceHistoryListingApi = "/fleece-inventory/list-fleece-history";
export const fleeceDownloadCsvApi = "/fleece-inventory/download-excel-fleece";
export const fleeceItemListingByInvoice = function (invoice_id) {
  return `/fleece-inventory/fleece-item-listing-by-invoice/${invoice_id}`;
};
export const fleeceEditInvoiceItemInventory = function (invoice_id) {
  return `/fleece-inventory/edit-invoice-item-inventory/${invoice_id}`;
};

//Approval
export const fetchFleeceApprovalApi = `/approval/fleece-approval-invoice-listing`;
export const fetchFleeceItemsApprovalApi = function (id, invoice_id) {
  return `/approval/fleece-approval-item-listing-by-invoice/${id}/${invoice_id}`;
};
export const fleeceApproveInvoiceApi = function (id, invoice_id) {
  return `/approval/fleece-approve_invoice_details/${id}/${invoice_id}`;
};
export const fleeceRejectInvoiceApi = function (id, invoice_id) {
  return `/approval/fleece-reject_invoice_details/${id}/${invoice_id}`;
};

export const fetchFleeceInwardNo = async (id) => {
  const res = await Axios.get(`/fleece-inventory/inward-sr-no-dropdown/${id}`);
  return res;
};
export const fetchFleeceNoDropdown = async (id, itemId) => {
  const res = await Axios.get(
    `/fleece-inventory/item-sr-no-dropdown/${id}/${itemId}`
  );
  return res;
};
export const fetchFleeceNoById = async (id) => {
  const res = await Axios.get(`/fleece-inventory/list-fleece-details/${id}`);
  return res;
};

export const addRawOrderFleece = async (data) => {
  const res = await Axios.post(
    "/order/issue-raw-fleece-paper-order/issue-order",
    data
  );
  return res;
};
export const revertRawOrderFleece = async (id) => {
  const res = await Axios.post(`/order/revert-order/${id}`);
  return res;
};
